import{ customIcons } from "../../../constants";
import { ResponseType } from "../../../Types/ServicesType/servicesType";
import { SettingsDataType, SettingsTableDataType, SaveResponseType, SearchParamsType, MenuParentType } from "./types";
import * as MuiIcons from '@mui/icons-material'
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const {clinicId} = getConstants()
const {SettingsApi} = api
export const getSettingsTableData = async (params:SearchParamsType):Promise<ResponseType<{items:SettingsTableDataType[],total:number}>>=>{
    const result = await instance.post(`${SettingsApi.menuSettingsList}`,{...params,clinicId});
    return result.data;
}

export const getMenuParentList = async ():Promise<ResponseType<MenuParentType[]>>=>{
    const result = await instance.get(`${SettingsApi.menuParentList}${clinicId}`);
    return result.data;
}

export const saveMasterData = async (params:SettingsDataType):Promise<ResponseType<SaveResponseType>>=>{
    const result = await instance.post(`${SettingsApi.saveMenuSettings}`,params);
    return result.data;
}

export const updateMasterData = async (params:SettingsDataType[]):Promise<ResponseType<SaveResponseType>>=>{
    const result = await instance.put(`${SettingsApi.updateMenuSettings}`,params);
    return result.data;
}

export const getIcons = async ():Promise<{icon:string}[]>=>{
const allIcons = Object.entries(MuiIcons).map(i=>({icon:i[0]}))
const localIcons = Object.entries(customIcons).map(item=>({icon:item[0]}))
return [...allIcons,...localIcons]
}
